// extracted by mini-css-extract-plugin
module.exports = {"sys":"system_sys__EzqyW"};